import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { HistoryEntryDto } from 'src/app/entities/OperationLogDto';
import { DataService } from 'src/app/services/data.service';
import { MenuService } from 'src/app/services/menu-service';
import { HistorySearch } from 'src/app/entities/HistorySearch';
import { DeviceMapDialogComponent } from 'src/app/pagecomponents/devices/device-map-dialog/device-map-dialog.component';

@Component({
  selector: 'app-operations-log',
  standalone: false,
  templateUrl: './operations-log.component.html',
  styleUrl: './operations-log.component.css'
})
export class OperationsLogComponent implements OnInit, OnDestroy {
  isLoadingStaticData = true;
  loadingSub: Subscription | undefined;
  historyEntries : HistoryEntryDto[] = [];

  search: HistorySearch = {
    startDate: new Date(new Date().setDate(new Date().getDate() - 3)), //3 days ago
    endDate: new Date(),
    licensePlate: '',
    userEmail: ''
  };

  private sortField: string = 'DateTime'; //needs to be the same value as <table matSortActive="..">
  private sortDirection: string = 'desc';  //needs to be the same value as <table matSortDirection="..">

  public searchChangeSubject = new Subject<void>();

  constructor(private menuService: MenuService,
              private data: DataService,
              private dialog: MatDialog
            ) { }

  ngOnInit(): void {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      if (this.menuService.GetActiveMenuName() == 'Storico') {
        if (status) {
          this.applySearch();
          this.data.refreshHistoryEntries(this.search).subscribe();
          this.data.startHistoryEntriesPolling();
        }
      }
      else {
        this.data.stopHistoryEntriesPolling();
      }
    });

    this.data.historyEntries$.subscribe(logs => { //callback per lo stream di history
      this.historyEntries = logs;
      if (this.menuService.GetIsLoadingInProgressScreen())
        this.menuService.StopLoadingInProgressScreen();
      this.isLoadingStaticData = false;

      this.filteredHistoryEntries = logs;
      this.applySorting();
    });

    this.searchChangeSubject.pipe(
      debounceTime(400)
    ).subscribe(() => {
      this.applySearch();
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }

    this.data.stopHistoryEntriesPolling();
  }

  applySearch() {
    this.data.setSearch(this.search);
  }

  trackById(index: number, item: HistoryEntryDto): any {
    return item.LicensePlate;
  }
  
  onMatSortChange(sortState: Sort) {
    this.sortField = sortState.active as keyof HistoryEntryDto;
    this.sortDirection = sortState.direction;

    this.applySorting();
  }

  filteredHistoryEntries: HistoryEntryDto[] = [];

  applySorting() {
    const result = [...this.historyEntries];

    const sortDir = this.sortDirection?.toLowerCase();
    const sortField = this.sortField as keyof HistoryEntryDto;

    if ((sortDir !== 'asc' && sortDir !== 'desc') || !sortField) {
      this.filteredHistoryEntries = result;
      return;
    }

    const direction = sortDir === 'asc' ? -1 : 1;

    result.sort((a, b) => {
      let valA = a[sortField];
      let valB = b[sortField];

      if (this.sortField === 'DevicePosition') {
        valA = `${a.DeviceLatitude}${a.DeviceLongitude}`;
        valB = `${b.DeviceLatitude}${b.DeviceLongitude}`;
      }
      else if (this.sortField === 'ClientPosition') {
        valA = `${a.ClientLatitude}${a.ClientLongitude}`;
        valB = `${b.ClientLatitude}${b.ClientLongitude}`;
      }

      if (valA == null && valB == null) return 0;
      if (valA == null) return 1 * direction;
      if (valB == null) return -1 * direction;

      if (typeof valA === 'number' && typeof valB === 'number') {
        return (valA - valB) * direction;
      }

      return valB
        .toString()
        .toLowerCase()
        .localeCompare(valA.toString().toLowerCase()) * direction;
    });

    this.filteredHistoryEntries = result;
  }

  getOpenStreetMapUrl(lat: number, lon: number): string {
    return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}&zoom=16`;
  }

  async onRowMouseUp(event: MouseEvent, row: any): Promise<void> {
    const selection = window.getSelection();

    // If text is selected, do not select row
    if (selection && selection.toString().length > 0) {
      return;
    }

    await this.onRowSelected(row);
  }
  
  async onRowSelected(row: HistoryEntryDto) {

  }

  async onRowClick(row: HistoryEntryDto) {
    const dialogRef = this.dialog.open(DeviceMapDialogComponent, {
      width: '70%',
      height: '70%',
      maxWidth: 'none',
      autoFocus: false,
      data: row,
      disableClose: true // previene chiusura tramite ESC e click fuori dalla dialog (verranno gestiti a mano
                          // nel dialog per mostrare un ulteriore dialog di conferma quando ci sono pending changes)
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('afterClosed', result);
    });
  }
}
